// extracted by mini-css-extract-plugin
module.exports = {"container":"BrandBanner_container__0HGmv","chanelStripe":"BrandBanner_chanelStripe__pYAoI","chanel":"BrandBanner_chanel__3KdW_","banner":"BrandBanner_banner__kX1RG"};